import {Box, Button, Link, Typography} from "@mui/material"
import {formatDateWithYear} from "../../../../../utils/dates"
import NoteAttachmentBreadcrumbs from "./AttachmentBreadcrumbs"
import {FileOpenOutlined} from "@mui/icons-material"

export function AttachmentBody({attachment, noteAttachmentBreadcrumbs, isPreview}) {

	return (
		<>
			<Typography
				variant={"body1"}
				sx={{
					marginBottom: 0,
					wordBreak: "break-word",
					whiteSpace: "pre-line"
				}}
				paragraph={attachment.attachmentType === "file" ? false : true}
			>
				{ attachment.attachmentType === "doc" ?
					`Refzoom Document created on ${formatDateWithYear(new Date(attachment.createdAt))}`
					:
					attachment.description
				}
			</Typography>
			{ attachment.attachmentType === "url" && (
				<a
					href={attachment?.url?.startsWith("http") ? attachment?.url : `http://${attachment.url}`}
					target="_blank"
					rel="noopener noreferrer"
				>
					{attachment.url}
				</a>
			)}
			{ attachment.attachmentType === "doc" && (
				<Button
					variant="outlined"
					component={Link}
					href={attachment?.url}
					target="_blank"
					rel="noopener noreferrer"
					startIcon={ <FileOpenOutlined /> }
				>
					Open Refzoom Document Viewer
				</Button>
			)}
			<Box sx={{margin: "8px 0"}}>
				{
					noteAttachmentBreadcrumbs[attachment.id]?.map(note => {
						return (
							<NoteAttachmentBreadcrumbs
								key={note.id}
								note={note}
								isParent={true}
								attachment={attachment}
								preview={isPreview}
							/>
						)

					})
				}
			</Box>
		</>
	)
}

export function DescriptionPreview({attachment}) {

	return attachment.attachmentType === "doc" ? (
		<Typography
			variant={"body1"}
			sx={{
				marginBottom: 0,
				flex: "1",
				overflow: "hidden",
				whiteSpace: "nowrap",
				textOverflow: "clip", // Clips overflow without an ellipsis
			}}
			paragraph
		>
			{`Refzoom Document created on ${formatDateWithYear(new Date(attachment.createdAt))}`}
		</Typography>
	) : (
		<Typography
			variant={"body1"}
			sx={{
				marginBottom: 0,
				flex: "1",
				overflow: "hidden",
				whiteSpace: "nowrap", // Keeps text on a single line
				textOverflow: "clip", // Clips overflow without an ellipsis
			}}
			paragraph
		>
			{attachment.description}
		</Typography>
	)
}